module.exports = __webpack_public_path__ + "static/media/landingpage_logo.24fb4d07.png";